import { AmendmentState } from 'lib/graphql';

export const errorStates: AmendmentState[] = ['FAILED', 'BLOCKED', 'INVALID'];
